import styled from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { getEllipticableCss, getTypographyColorToken, getTypographyOptions, getVariant } from './helpers';
import { TypographyProps } from './types';

const resetMarginElements = ['p', 'h1', 'h2', 'h3'];

export const Typography = styled.div<TypographyProps>`
    margin: ${({ as }) => (typeof as === 'string' && resetMarginElements.includes(as) ? 0 : 'unset')};
    ${({ preset }) => getTextPresetCss(TEXT_PRESET_KEY[preset])};
    color: ${(props) => getTypographyColorToken({ variant: getVariant(props) })};
    ${getTypographyOptions}
    ${getEllipticableCss}
`;
